import React from 'react';
import Img from 'img';
import Icon from 'icon';
import Miscellaneous from 'shared/hero-miscellaneous';
import { Link } from 'gatsby';
import Headline from 'headline';
import CategoryPill from 'shared/category-pill';
import { useHeroImage } from '../../../hooks/useHeroImage';
import 'swiper/dist/css/swiper.css';
import s from './hero-featured.module.scss';

export default function HeroSlider({
  featuredImage,
  username,
  firstName,
  lastName,
  category,
  mobile_image,
  id,
  ...props
}) {
  const image = featuredImage?.id;
  const { heroImage } = useHeroImage({ image, mobile_image });

  return (
    <section className={s.root}>
      <div className={s.wrapper}>
        <div className={s.overlay} />
        <div className={s.imgWrapper}>
          <Img className={s.img} src={heroImage} alt={`@${heroImage?.title}`} />
        </div>
        <div className={`container ${s.content}`}>
          <div className={s.pillWrapper}>
            <CategoryPill category={category?.name} />
          </div>
          <Link to={`/influencers/${username}`} className={s.link}>
            <Headline
              className={s.title}
              center
              h1
              white
              html={`${firstName} ${lastName}`}
            />
          </Link>
          <Miscellaneous />
        </div>
      </div>
    </section>
  );
}
